/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetMyFeatureAccessQueryResponse,
  GetMyFeatureAccessPathParams,
} from "../types/GetMyFeatureAccess.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getMyFeatureAccessQueryKey = (
  featureKey: GetMyFeatureAccessPathParams["featureKey"] | undefined
) =>
  [
    {
      url: "/v1/access-management/me/features/:featureKey",
      params: { featureKey: featureKey },
    },
  ] as const

export type GetMyFeatureAccessQueryKey = ReturnType<
  typeof getMyFeatureAccessQueryKey
>

/**
 * @summary Get current organization feature access
 * {@link /v1/access-management/me/features/:featureKey}
 */
export async function getMyFeatureAccess(
  featureKey: GetMyFeatureAccessPathParams["featureKey"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetMyFeatureAccessQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/access-management/me/features/${featureKey}`,
    ...requestConfig,
  })
  return res
}

export function getMyFeatureAccessQueryOptions(
  featureKey: GetMyFeatureAccessPathParams["featureKey"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getMyFeatureAccessQueryKey(featureKey)
  return queryOptions<
    ResponseConfig<GetMyFeatureAccessQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetMyFeatureAccessQueryResponse>,
    typeof queryKey
  >({
    enabled: !!featureKey,
    queryKey,
    queryFn: async ({ signal }) => {
      return getMyFeatureAccess(featureKey!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get current organization feature access
 * {@link /v1/access-management/me/features/:featureKey}
 */
export function useGetMyFeatureAccess<
  TData = ResponseConfig<GetMyFeatureAccessQueryResponse>,
  TQueryData = ResponseConfig<GetMyFeatureAccessQueryResponse>,
  TQueryKey extends QueryKey = GetMyFeatureAccessQueryKey,
>(
  featureKey: GetMyFeatureAccessPathParams["featureKey"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetMyFeatureAccessQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getMyFeatureAccessQueryKey(featureKey)

  const query = useQuery(
    {
      ...getMyFeatureAccessQueryOptions(featureKey, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
